import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "radio-selected",
  "use": "radio-selected-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"radio-selected\">\n<g clip-path=\"url(#radio-selected_clip0_1106_21104)\">\n<rect x=\"2\" y=\"2\" width=\"14\" height=\"14\" rx=\"7\" fill=\"#C79E6B\" />\n<rect width=\"18\" height=\"18\" rx=\"9\" stroke=\"#616161\" />\n</g>\n<defs>\n<clipPath id=\"radio-selected_clip0_1106_21104\">\n<rect width=\"18\" height=\"18\" rx=\"9\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol